import type EnType from '../en-US/apiTest';

export default {
  'apiTestCase.messageError.praseError': 'Error de Análisis',
  'apiTestCase.messageError.csvFormatError': 'No cumple con el formato CSV',
  'apiTestCase.csvStandardRules': '《Especificación Estándar CSV》',
  'apiTestCase.report.statusCode': 'Estado',
  'apiTestCase.report.statusLabel': 'Estado HTTP: ',
  'apiTestCase.report.timeConsume': 'Tiempo',
  'apiTestCase.report.TabSizeMap': 'Tamaño',
  'apiTest.label.actualRequest': 'Solicitud Real',
  'apiText.response.timings.event': 'EVENTO',
  'apiText.response.timings.event.prepare': 'Preparar',
  'apiText.response.timings.event.socket': 'Inicialización de Socket',
  'apiText.response.timings.event.dns': 'Búsqueda DNS',
  'apiText.response.timings.event.tcp': 'Apretón de Mano TCP',
  'apiText.response.timings.event.ssl': 'Apretón de Mano SSL',
  'apiText.response.timings.event.transfer': 'Esperando (TTFB)',
  'apiText.response.timings.event.download': 'Descarga de Contenido',
  'apiText.response.timings.event.process': 'Procesando',
  'apiText.response.timings.event.total': 'Total',
  'apiText.response.timings.timeLabel': 'TIEMPO',
  'apiTest.debug.extension.install': 'Instalar',
  'apiTest.debug.extension.install.tips':
    'Por favor instala la extensión del navegador {appName} para enviar solicitudes. Solo admite navegadores Chrome y Edge.',
  'apiText.response.error.message.fallback': 'Error: {message}',
  'apiText.response.error.help': 'ayuda',
  'apiTest.debug.usedTemplateVar': 'La API usa variables de entorno {variables}',
  'apiTest.debug.setTemplateVar': 'Por favor configura las variables de entorno {variables}',
  'apiTest.debug.toSetVar': 'Ir a establecer valor',
  'apiTestCase.threadResources': 'Preparación de recursos de hilo en progreso',
} satisfies typeof EnType;
